import React from 'react';

function EmailSendOutline({ color = '#335B70', secondaryColor = '#335B70', ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
            <path
                fill={color}
                d="M9 9.75 3 6v7.5h6.75V15H3c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06v-9c0-.412.147-.766.44-1.06C2.235 3.148 2.588 3 3 3h12c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06v5.25H15V6L9 9.75Zm0-1.5 6-3.75H3l6 3.75Zm5.25 9L13.2 16.2l1.181-1.2H11.25v-1.5h3.131l-1.2-1.2 1.069-1.05 3 3-3 3ZM3 6v8.25-4.5.056V4.5 6Z"
            />
        </svg>
    );
}

export default EmailSendOutline;
